module.exports = __webpack_public_path__ + "img/peruri-logo-alt.b6b5bce9.png";